import {ID} from "../model/id"
import * as React from "react"
import {
  BookingGutsFragment,
  ExtraChargeInput,
  InvoiceBookings,
  PastPassengers as PAST_PASSENGERS,
  PastPassengersQueryVariables,
  PlaceSuggest as PLACE_SUGGESTIONS,
  SetBookingsHidden,
} from "../graphql/queries"
import {GraphQL, makeQueryWithVarsNoT} from "../graphql"
import {ExtraCharge} from "./ExtraChargeList"
import {errorUnionToEither, OrError} from "../graphql/errors"

export function extraChargesToInputExtraCharges(
  charges: Array<ExtraCharge>,
): Array<ExtraChargeInput> {
  return charges.map(({amount, description, id, type}) => ({amount, description, id, type}))
}

export const bookingNotesHelpMessage =
  "Anything that will help us find you or other extra requirements of the booking."

export function refetchQueries(localeId: ID, ppVariables: PastPassengersQueryVariables) {
  return [
    makeQueryWithVarsNoT({
      query: PLACE_SUGGESTIONS,
      variables: {localeId, text: ""},
    }),
    makeQueryWithVarsNoT({
      query: PAST_PASSENGERS,
      variables: ppVariables,
    }),
  ]
}

export async function onInvoiceBookingMutation(ids: Array<ID>) {
  const data = await GraphQL.mutate(InvoiceBookings, {ids})
  return errorUnionToEither(data.invoiceBookings).map((x) => x.bookings)
}

export async function onBookingSetHidden(
  ids: Array<ID>,
  hidden: boolean,
): Promise<OrError<Array<BookingGutsFragment>>> {
  const data = await GraphQL.mutate(SetBookingsHidden, {ids, hidden})
  return errorUnionToEither(data.setBookingsHidden).map((x) => x.bookings)
}



// WEBPACK FOOTER //
// ./src/components/BookingWizard.tsx